/* rb-b-scroll.js — after a filter change, return to the top of the results.

   Loaded last. Separate file so the big base scripts never need rewriting for a
   small addition (see the note in rb-b-loader.liquid).

   WHY THIS IS NEEDED
   theme.js only scrolls up for PAGINATION — paginationControl passes
   scrollUp:true. Filter changes and clear-all deliberately leave the scroll
   position alone, so picking a tag while halfway down the grid swaps the
   products underneath you and strands you in the middle of a set whose
   beginning you never saw.

   "SOMETIMES IT TAKES YOU TO THE TOP, SOMETIMES IT DOESN'T" — TWO CAUSES, BOTH
   REPRODUCED BEFORE BEING FIXED:

   1. A filter change is not one DOM update. Measured on /shirts: the section
      emits FOUR mutation bursts spread over 694–1071ms. The first version
      consumed its arming flag on the FIRST burst, scrolled 120ms later and
      re-asserted for only 600ms — so when the later bursts landed after that
      window (slow network, cold images, busy machine) the correction had
      already stopped. Now it stays armed for several seconds, DEBOUNCES until
      the bursts go quiet, and holds longer. Repeated calls are harmless
      because it only ever scrolls UP.

   2. TRACKPAD MOMENTUM. "Never fight a hand" was implemented as: any wheel
      event cancels everything. But inertia from the flick that brought you to
      the filter keeps firing wheel events for a few hundred ms AFTER the
      click. Reproduced exactly — a single deltaY:8 wheel at +0ms, +120ms and
      +400ms after the click killed the scroll all three times. So a short
      grace period now ignores SMALL wheel deltas straight after a filter
      click, while a decisive scroll (|deltaY| >= 40) still wins immediately,
      as does any key press or touch.

   THE OTHER CONSTRAINTS, LEARNED ON D2 AND STILL TRUE:
     - ONLY EVER SCROLL UP, or ticking several values yanks the page each time.
     - CLEAR THE HEADER, MEASURED. It is sticky with a transform: height is
       always 102px but the bottom edge is 137 at rest and 0 once it slides
       away; it is 172px on an iPad Mini. Use the bottom edge.
     - INSTANT, NEVER behavior:'smooth' — smooth is silently swallowed here.
       Verified: 'auto' moves the page, 'smooth' does nothing. */

(function () {
  'use strict';

  if (!window.matchMedia('(min-width: 981px)').matches) return;

  var GAP = 12;
  var ARM_MS = 6000;      // how long after a filter click we stay interested
  var QUIET_MS = 250;     // bursts must go quiet this long before we scroll
  var HOLD_MS = 1800;     // how long to keep correcting after scrolling
  var GRACE_MS = 900;     // ignore trackpad inertia for this long after a click
  var DECISIVE = 40;      // a wheel this big is intent, not inertia

  var armedUntil = 0;
  var armedAt = 0;
  var debounce = null;
  var holdUntil = 0;
  var holding = false;

  function headerBottom() {
    var g = document.querySelector('.shopify-section-group-header-group');
    if (!g) return 0;
    var pos = getComputedStyle(g).position;
    if (pos !== 'sticky' && pos !== 'fixed') return 0;
    return Math.max(0, Math.round(g.getBoundingClientRect().bottom));
  }

  /* The top of the results row — the filter column and the results bar share
     this edge, so landing here shows the count, the applied pills and the first
     row of products together. */
  function target() {
    var el = document.querySelector('.rbb-layout')
          || document.querySelector('.collection-products')
          || document.querySelector('.collection-main');
    if (!el) return null;
    return Math.max(0, Math.round(el.getBoundingClientRect().top + window.pageYOffset - headerBottom() - GAP));
  }

  function arm() {
    armedUntil = Date.now() + ARM_MS;
    armedAt = Date.now();
  }

  /* The shopper has taken over — stop everything. */
  function surrender() {
    armedUntil = 0;
    holdUntil = 0;
    clearTimeout(debounce);
  }

  window.addEventListener('wheel', function (e) {
    var decisive = Math.abs(e.deltaY) >= DECISIVE;
    // Inertia from the flick that brought them to the filter is not intent.
    if (!decisive && Date.now() - armedAt < GRACE_MS) return;
    surrender();
  }, { passive: true });

  ['touchstart', 'keydown'].forEach(function (t) {
    window.addEventListener(t, surrender, { passive: true });
  });

  function hold() {
    if (Date.now() > holdUntil) { holding = false; return; }
    var want = target();
    // Only ever correct DOWNWARD drift; never push the shopper further down.
    if (want != null && window.pageYOffset > want + 8) window.scrollTo(0, want);
    setTimeout(hold, 60);
  }

  function goUp() {
    var top = target();
    if (top == null) return;
    if (window.pageYOffset > top + 4) window.scrollTo(0, top);

    holdUntil = Date.now() + HOLD_MS;
    if (!holding) { holding = true; setTimeout(hold, 60); }
  }

  /* Arm on any real filter interaction: a value checkbox, a chip in the results
     bar, clear-all, or one of the theme's js-filter-trigger links. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.collection-sidebar__filter-form') ||
        t.closest('.js-filter-trigger') ||
        t.closest('.collection__filters-active')) {
      // Not the accordion headers, and not the facet search box.
      if (t.closest('summary') || t.closest('.rbb-find')) return;
      arm();
    }
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.collection-sidebar__filter-form')) arm();
  }, true);

  var section = document.querySelector('.js-section__collection');
  if (!section || !window.MutationObserver) return;

  new MutationObserver(function () {
    if (Date.now() > armedUntil) return;      // not a filter change, or we surrendered
    clearTimeout(debounce);
    // Wait for the bursts to stop so the target is measured against the FINAL
    // layout rather than an intermediate one.
    debounce = setTimeout(goUp, QUIET_MS);
  }).observe(section, { childList: true, subtree: true });
})();
